import Vue from "vue";
import Router from "vue-router";
import encryptStorage from "@/flit2go-web-core/util/encryptUtil";

// Axios
import conn from "@/flit2go-web-core/services/connection";

// Components
import Error from "@/flit2go-web-core/pages/Error";
import Forbidden from "@/flit2go-web-core/pages/Forbidden";
import HelpCenterLogin from "@/base/pages/HelpCenterLogin";
import HelpCenterUnavailable from "@/base/pages/HelpCenterUnavailable";
import Login from "@/base/pages/Index";
import NotFound from "@/flit2go-web-core/pages/NotFound";
import Profile from "@/base/pages/Profile";
import Settings from "@/base/pages/Settings";
import Wrapper from "@/base/pages/IntranetWrapper.vue";

// Stores
import store from "@/flit2go-web-core/store/index";

// Routes
import administrationRoutes from "@/modules/Administration/router";
import configurationRoutes from "@/modules/Configuration/router";
import controlRoutes from "@/modules/Control/router";
import dealerRoutes from "@/modules/Dealer/router";
import ownerRoutes from "@/modules/Owners/router";
import peopleRoutes from "@/modules/People/router";
import supportRoutes from "@/modules/Support/router";
import vehicleRoutes from "@/modules/Vehicles/router";

// Menu Structure
import menuStructureFile from "@/base/menuStructure/menuStructure.js";

// Code
Vue.use(Router);

let childrenRoutes = [
  {
    path: "settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true,
      breadcrumb: [{ name: "common.settings", link: "/settings" }],
    },
  },
  {
    path: "profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "error",
    name: "Error",
    component: Error,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "forbidden",
    name: "Forbidden",
    component: Forbidden,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "help-center-unavailable",
    name: "HelpCenterUnavailable",
    component: HelpCenterUnavailable,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "404-Error",
    name: "404-Error",
    component: NotFound,
  },
];

childrenRoutes = childrenRoutes.concat(
  ownerRoutes,
  vehicleRoutes,
  supportRoutes,
  peopleRoutes,
  administrationRoutes,
  configurationRoutes,
  dealerRoutes,
  controlRoutes
);

const routes = [
  {
    path: "/login",
    name: "index",
    component: Login,
  },
  {
    // Login URL configured in Zoho Desk for the help center web portal, outside the Manager layout
    path: "/help-center-login",
    name: "HelpCenterLogin",
    component: HelpCenterLogin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/s",
    name: "Manager",
    meta: {
      requiresAuth: true,
    },
    redirect: {
      path: redirectToFirstLinkAllowed(),
    },
    component: Wrapper,
    children: childrenRoutes,
  },
  {
    path: "/",
    redirect: { name: "Manager" },
  },
  {
    path: "*",
    redirect: { name: "404-Error" },
  },
];

const router = new Router({
  routes,
});

function redirectToFirstLinkAllowed() {
  if (store.getters["auth/isAuthenticated"]) {
    return menuStructureFile.getFirstLinkAllowed();
  } else {
    return "";
  }
}

function getRoleUpdate() {
  var update = localStorage.getItem("update");
  return conn.$axios({
    url: `/secured/v1/permissions/update/${update}`,
    method: "GET",
    headers: { Authorization: "Bearer " + localStorage.getItem("user-token") },
  });
}

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("update") !== "null" ) {
    if (from.path !== "/" && to.path !== "/login") {
      getRoleUpdate().then((resp) => {
        if (resp.status === 200) {
          localStorage.setItem("update", resp.data[0].update);
          encryptStorage.setItem("user-role", JSON.stringify(resp.data));
          window.location.reload();
        }
      });
    }
  }

  var nextParams = {};
  var hasPermission = true;
  // this route requires auth, check if logged in
  // if not, redirect to login page.
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // router.app is the app global instance
    if (!router.app.$store.getters["auth/isAuthenticated"]) {
      nextParams = {
        path: "/login",
        query: { redirect: to.fullPath, error: true, msg: "Not logued in" },
      };
      next(nextParams);
    }
  }

  if (
    router.app.$store.state.auth.userRole &&
    router.app.$store.state.auth.userRole.length > 0
  ) {
    const isVehicleForm = to.path.includes("vehicles/form");
    const isCorporateNetworkForm = to.path.includes("corporateNetwork/form");
    const isBranchForm = to.path.includes("branch/form");
    const isVehicleTransfer = to.path.includes("vehicles/transfer");

    router.app.$store.state.auth.userRole.forEach((module) => {
      module.submodules.forEach((submodule) => {
        if (submodule.code === to.meta.code) {
          const isFormAndHasFilter = (isVehicleForm || isCorporateNetworkForm || isBranchForm) && submodule.hasFilter;
          const isTransferVehicleAndNoWritePerms = isVehicleTransfer && !submodule.w;
          const noPerms = !submodule.r && !submodule.w;
          if (isFormAndHasFilter || noPerms || isTransferVehicleAndNoWritePerms) {
            hasPermission = false;
          }
        }
      });
    });
  } else {
    hasPermission = true;
  }
  if (!hasPermission) {
    next("/s/forbidden");
  } else {
    next();
  }
});

export default router;
